import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Button from 'react-bootstrap/Button';

import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import { postDataHelper } from "../requests/PostRequests";

const Login = ({ onTriggerMessage }) => {
  const [loginCreds, setLoginCreds] = useState({ username: "", password: "" });
  const navigate = useNavigate()
  const { username, password } = loginCreds;

  async function getAuthToken() {
    const onSuccess = (data) => {
      navigate('/');
    };

    await postDataHelper("/auth/login",
      { username: loginCreds.username, password: loginCreds.password },
      onTriggerMessage,
      onSuccess);
  };

  const onChangeHandler = (e) => {
    setLoginCreds({ ...loginCreds, [e.target.name]: e.target.value });
  }

  async function loginHandler(e) {
    e.preventDefault();
    await getAuthToken();
  }

  return (
    <div className="login-bg">
      <Card className='login-card' style={{ width: '30rem' }}>
        <Card.Body>
          <Card.Title as="h3" className='login-card-title'>Login</Card.Title>
          <Form onSubmit={loginHandler}>
            <FloatingLabel controlId="floatingInput" label="Username" className="mb-3">
              <Form.Control type="text" placeholder="Username" name="username" value={username} onChange={onChangeHandler} />
            </FloatingLabel>
            <FloatingLabel controlId="floatingPassword" label="Password">
              <Form.Control type="password" placeholder="Password" name="password" value={password} onChange={onChangeHandler} />
            </FloatingLabel>
            <div className="d-grid gap-2 login-btn">
              <Button variant="custom-secondary" size="lg" type="submit">
                Login
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Login;
